import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import MoreOutlinedIcon from '@/assets/icons/menu-vertical.svg?react'
import Button, {
  type ButtonProps,
  type ButtonVariant
} from '@/components/Button/Button'
import type { DistributiveOmit } from '@/types/utils'

import styles from './Actions.module.scss'
import Dropdown, { DropdownMenuItem } from '../../Dropdown/Dropdown'
import ActionsDrawer from '../ActionsDrawer/ActionsDrawer'

export type Action = {
  onClick?: () => void
  variantButton?: ButtonVariant
  variantAction?: 'normal' | 'danger'
  text: string
  hidden?: boolean
} & DistributiveOmit<ButtonProps, 'children' | 'variant' | 'onClick'>

type ActionsProps = {
  actions?: Action[]
  actionsAsDropdown?: boolean
}

const Actions = (props: ActionsProps) => {
  const { t } = useTranslation('common')

  return props.actions?.length ? (
    <>
      <div className={styles.buttonWrapper}>
        {props.actionsAsDropdown ? (
          <Dropdown
            sideOffset={-10}
            trigger={
              <Button
                dataTestId="more-button"
                variant="secondary"
                icon={<MoreOutlinedIcon />}
              >
                {t('button.more')}
              </Button>
            }
          >
            {props.actions?.map((action, index) => {
              const {
                variantButton: _,
                // Should this be unused?
                hidden: __,
                icon,
                text,
                variantAction,
                ...buttonProps
              } = action

              return (
                <DropdownMenuItem key={index}>
                  <Button
                    {...buttonProps}
                    variant="tertiary"
                    className={styles.actionButton}
                  >
                    <div
                      className={clsx(
                        styles.action,
                        variantAction === 'danger' && styles.actionDanger
                      )}
                    >
                      <span className={styles.actionIcon}>{icon}</span>
                      <span>{text}</span>
                    </div>
                  </Button>
                </DropdownMenuItem>
              )
            })}
          </Dropdown>
        ) : (
          props.actions?.map((action, index) => {
            const {
              variantAction: _,
              // Should this be unused?
              hidden: __,
              variantButton,
              text,
              ...buttonProps
            } = action

            return (
              <Button
                {...buttonProps}
                key={index}
                variant={variantButton || 'secondary'}
              >
                {text}
              </Button>
            )
          })
        )}
      </div>

      <ActionsDrawer
        actions={props.actions.map(action => ({
          ...action,
          isDanger: action.variantAction === 'danger'
        }))}
        onlyMobile
        triggerButtonSize="medium"
      />
    </>
  ) : null
}

export default Actions
